module.exports = __webpack_public_path__ + "img/8.bdf830de.jpg";